<template>
  <div id="dashboard" class="content">
    <!-- <div class="row">
      <div class="col-12">
        <a class="block block-rounded block-link-shadow" href="javascript:void(0)">
          <div class="block-header block-header-default">
            <h3 class="block-title">总用电量(度)</h3>
          </div>
          <div class="block-content block-content-full">
            <div class="row text-center">
              <div class="col-12"></div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                  >{{(stats && stats.yesterdayDegree+'') || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.startDate}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p class="font-size-125 font-w300 mb-0">{{(stats && stats.sumDegree+'') || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.label}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                    v-html="(stats && compare(stats.seqDegree)+'')  || '--'"
                  ></p>
                  <p class="text-muted mb-0 font-size-75">环比</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="chart-seq-degree" style="width: 100%; height: 200px"></div> 
            </div>
          </div>
        </a>
      </div>
    </div>-->
    <div class="row">
      <div class="col-md-6 col-xl-3">
        <!-- @click="clickUrlPermisson('carportMeterList')?$router.push({name: 'carportMeterList', params:{id:'carportMeterList'}}):''" -->
        <a class="block text-center" href="javascript:void(0)">
          <div class="block-content" style="padding-bottom: 1.25rem">
            <div>
              <div
                class="js-pie-chart pie-chart mb-3"
                :data-percent="entry.num_meters_online / entry.num_meters * 100"
                data-line-width="3"
                data-size="70"
                data-bar-color="#3c90df"
                data-track-color="#e9e9e9"
                style="min-height: 70px"
              >
                <span
                  class="font-size-75"
                >{{entry.num_meters_online || 0}}/{{entry.num_meters || 0}}</span>
              </div>
              <p class="text-muted mt-2 mb-0 font-size-75">电表(在线数/总数)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <!-- @click="clickUrlPermisson('carportCharge')?$router.push({name: 'carportCharge', params:{id:'carportCharge'}}):''" -->
        <a class="block text-center" href="javascript:void(0)">
          <div class="block-content" style="padding-bottom: 1.25rem">
            <div>
              <div
                class="js-pie-chart pie-chart mb-3"
                :data-percent="entry.num_online / entry.num_pile * 100"
                data-line-width="3"
                data-size="70"
                data-bar-color="#82b54b"
                data-track-color="#e9e9e9"
                style="min-height: 70px"
              >
                <span class="font-size-75">{{entry.num_online || 0}}/{{entry.num_pile || 0}}</span>
              </div>
              <p class="text-muted mt-2 mb-0 font-size-75">充电桩(在线数/总数)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block text-center" href="javascript:void(0)" style="cursor: auto">
          <div class="block-content" style="padding-bottom: 1.25rem">
            <div>
              <div
                class="js-pie-chart pie-chart mb-3"
                :data-percent="entry.num_port_online / entry.num_ports * 100"
                data-line-width="3"
                data-size="70"
                data-bar-color="#f2ad40"
                data-track-color="#e9e9e9"
                style="min-height: 70px"
              >
                <span class="font-size-75">{{entry.num_port_online || 0}}/{{entry.num_ports || 0}}</span>
              </div>
              <p class="text-muted mt-2 mb-0 font-size-75">端口(在线数/总数)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block text-center cursor-auto" href="javascript:void(0)" style="cursor: auto">
          <div class="block-content pt-0" style="padding-bottom: 1.1rem">
            <div>
              <div id="port" style="width: 100%; height: 130px" class="pt-2"></div>
              <!-- <p class="text-muted mt-2 mb-0 font-size-75" style="padding-top:0.25rem">端口(空闲/占用)</p> -->
            </div>
          </div>
        </a>
      </div>
    </div>
    <!-- <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">全部设备</h2>
        </div>
        <div class="col-6 text-right mr-0"></div>
      </div>
    </div>-->
    <div class="block block-rounded block-bordered">
      <ul
        class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
        data-toggle="tabs"
        role="tablist"
      >
        <li class="nav-item" v-for="(item,index) in bis" :key="index">
          <a
            class="nav-link"
            :class="['btabs-animated-fade-'+item.BIS_TYPE ,
              [bis.length>1&&(item.BIS_TYPE==type||index==0)?'active':''],
              [bis.length==1?' oneTable':'']]"
            href="javascript:void(0)"
            @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
          >{{item.BIS_NAME}}</a>
        </li>

        <li
          class="ml-auto nav-main-item add"
          v-if="!meterBtn && !chargePieBtn && !fictitiousBtn&& !carportBtn"
        ></li>
        <li
          class="ml-auto nav-main-item add"
          v-if="meterBtn||chargePieBtn||fictitiousBtn||carportBtn"
        >
          <a
            class="nav-main-link nav-main-link-submenu"
            data-toggle="submenu"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
          >
            <button type="button" class="btn-block-option add-btn mr-2" data-toggle="modal">
              <i class="fa fa-plus mr-1"></i> 绑定
            </button>
          </a>
          <ul class="nav-main-submenu">
            <!-- <li
              class="nav-main-item"
              data-toggle="modal"
              @click="create('meterList')"
              v-if="meterBtn"
            >
              <a class="nav-main-link" href="javascript:void(0)">
                <span class="nav-main-link-name">电表</span>
              </a>
            </li>-->
            <!-- <li
              class="nav-main-item"
              data-toggle="modal"
              @click="create('chargePie')"
              v-if="chargePieBtn"
            >
              <a class="nav-main-link" href="javascript:void(0)">
                <span class="nav-main-link-name">充电桩</span>
              </a>
            </li> -->
            <li
              class="nav-main-item"
              data-toggle="modal"
              @click="create('fictitious')"
              v-if="fictitiousBtn"
            >
              <a class="nav-main-link" href="javascript:void(0)">
                <span class="nav-main-link-name">虚拟电表</span>
              </a>
            </li>
            <!-- <li
              class="nav-main-item"
              data-toggle="modal"
              @click="create('carport')"
              v-if="carportBtn"
            >
              <a class="nav-main-link" href="javascript:void(0)">
                <span class="nav-main-link-name">智能门闸</span>
              </a>
            </li> -->
          </ul>
        </li>
        <div class="block-header block-header-default" style="padding-left: 0;">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </ul>
      <div class="block-content tab-content overflow-hidden">
        <div
          class="tab-pane fade"
          id="btabs-animated-fade-1"
          role="tabpanel"
          v-show="isAllDevicePageTabs "
          :class="{' show active':  isAllDevicePageTabs }"
        >
          <allDeviceList ref="allDeviceList"></allDeviceList>
        </div>
        <div
          class="tab-pane fade"
          id="btabs-animated-fade-2"
          role="tabpanel"
          v-show="isMeterPageTabs "
          :class="{' show active': !isAllDevicePageTabs&& isMeterPageTabs }"
        >
          <carportMeter ref="carportMeter"></carportMeter>
        </div>
        <div
          class="tab-pane fade"
          id="btabs-animated-fade-3"
          role="tabpanel"
          v-show="isChargePageTabs  "
          :class="{' show active': !isAllDevicePageTabs&&!isMeterPageTabs && isChargePageTabs  }"
        >
          <carportCharge ref="carportCharge"></carportCharge>
        </div>
        <div
          class="tab-pane fade"
          id="btabs-animated-fade-4"
          role="tabpanel"
          v-show="isChargePageTabs  "
          :class="{' show active': !isAllDevicePageTabs&&!isMeterPageTabs && !isChargePageTabs &&isCarportPortPageTabs }"
        >
          <portList ref="portList"></portList>
        </div>
        <div
          class="tab-pane fade"
          id="btabs-animated-fade-5"
          role="tabpanel"
          v-show="isDevicePageTabs"
          :class="{' show active': !isAllDevicePageTabs&&!isMeterPageTabs  &&!isChargePageTabs &&!isCarportPortPageTabs&& isDevicePageTabs}"
        >
          <carportDevice ref="carportDevice"></carportDevice>
        </div>
      </div>
    </div>
    <!-- 绑定电表 -->
    <div
      class="modal fade"
      id="modal-default-normal-meterList-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-meterList-add"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">绑定电表</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  电表串号
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    maxlength="30"
                    v-model="form.electricityMeterSn"
                    @change="changeElectricityMeterSn()"
                  >
                    <el-option
                      v-for="(item,key) in electricityMeterSnList"
                      :key="key"
                      :label="item.ELECTRICITY_METER_SN"
                      :value="item.ELECTRICITY_METER_SN"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  电表名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.electricityMeterName"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  电表型号
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.electricityMeterModel"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    maxlength="30"
                    v-model="form.cellId"
                  >
                    <el-option
                      v-for="item in cellList"
                      :key="item.CELL_ID"
                      :label="item.CELL_NAME"
                      :value="item.CELL_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('meterList')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定充电桩 -->
    <div
      class="modal fade"
      id="modal-default-normal-chargePie-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-chargePie-add"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">绑定充电桩</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    maxlength="30"
                    v-model="form.cellId"
                  >
                    <el-option
                      v-for="item in allCellList"
                      :key="item.CELL_ID"
                      :label="item.CELL_NAME"
                      :value="item.CELL_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>-->
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  电表名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model="form.electricityMeterSn"
                    :filter-method="getSearchMeterVal"
                    v-el-select-loadmore="loadmoreMeter"
                  >
                    <el-option
                      v-for="(item,key) in searchMeterList"
                      :key="key"
                      :label="item.ELECTRICITY_METER_NAME"
                      :value="item.ELECTRICITY_METER_SN"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  充电桩设备号
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    maxlength="30"
                    v-model="form.chargingPileSn"
                    v-el-select-loadmore="loadmore"
                    :filter-method="getSearchChargingPileSnVal"
                    @change="changeChargingPileSn()"
                  >
                    <el-option
                      v-for="(item,key) in chargingPileSnList"
                      :key="key"
                      :label="item.CHARGING_PILE_SN"
                      :value="item.CHARGING_PILE_SN"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">充电桩编号</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder="请输入"
                    maxlength="30"
                    v-model="form.chargingPileName"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('chargePie')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定虚拟电表 -->
    <div
      class="modal fade"
      id="modal-default-normal-fictitious-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-fictitious-add"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">绑定虚拟电表</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    maxlength="30"
                    v-model="form.cellId"
                    @change="getSiteList(form.cellId)"
                  >
                    <el-option
                      v-for="item in allCellList"
                      :key="item.CELL_ID"
                      :label="item.CELL_NAME"
                      :value="item.CELL_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  站点名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control col-sm-12" v-model="form.siteId">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in siteList"
                      :key="index"
                      :value="item.SITE_ID"
                    >{{item.SITE_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  电表数量
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder maxlength="2" v-model="form.meterNum" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="fictitiousSubmit( )"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定门闸 -->
    <div
      class="modal fade"
      id="modal-default-normal-carport-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-carport-add"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">绑定智能门闸</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model="form.carportId"
                  >
                    <el-option
                      v-for="(item,key) in carportList"
                      :key="key"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  门闸名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.entranceGuardName"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  门闸编号
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" maxlength="16" v-model="form.deviceSn" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  进出方向
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.direct">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in directionList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group">
                <label  class="col-sm-12 control-label">状态</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model="form.status"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in statusList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('carport')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/pie");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/chart/map");
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";

import allDeviceList from "../../overview/carPortList/carportAllDeviceList";
import carportMeter from "./carportMeterList";
import carportCharge from "../../management/carportCharge/list";
import portList from "../../overview/carPortList/carportPortList";
import carportDevice from "../../management/carportDevice/list";

export default {
  name: "index",
  data() {
    return {
      degreeList: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      cellList: [],
      electricityMeterSnList: [],
      searchMeterList: [],
      chargingPileSnList: [],
      carportList: [],
      allCellList: [],
      siteList: [],
      directionList: [
        {
          value: "1",
          label: "进"
        },
        {
          value: "2",
          label: "出"
        },
        {
          value: "3",
          label: "进+出"
        }
      ],
      formData: {
        pageIndex: 1,
        pageSize: 20
      },
      MeterData: {
        pageIndex: 1,
        pageSize: 20
      },
      pro: "",
      city: "",
      dis: "",
      cellName: "",
      meterStatus: [
        {
          value: 1,
          label: "正常"
        },
        {
          value: 2,
          label: "故障"
        }
      ],
      deviceStatus: [
        {
          value: 1,
          label: "在线"
        },
        {
          value: 2,
          label: "离线"
        }
      ],
      sorting: "",
      orderBy: false,
      stats: null,
      charts: [],
      entryUrl: "",
      url: "",
      seeBtn: Util.isHavePerm("Pile/ListByMeterByCell"),
      type: 1,
      oldBis: [
        {
          BIS_NAME: "全部",
          BIS_TYPE: 1,
          SHOW_TAB: Util.isPageTabsPerm("carportAllDeviceList")
        },
        {
          BIS_NAME: "电表",
          BIS_TYPE: 2,
          SHOW_TAB: Util.isPageTabsPerm("carportMeterList")
        },
        {
          BIS_NAME: "充电桩",
          BIS_TYPE: 3,
          SHOW_TAB: Util.isPageTabsPerm("carportCharge")
        },
        {
          BIS_NAME: "端口",
          BIS_TYPE: 4,
          SHOW_TAB: Util.isPageTabsPerm("carportPort")
        },
        {
          BIS_NAME: "智能门闸",
          BIS_TYPE: 5,
          SHOW_TAB: Util.isPageTabsPerm("carportDevice")
        }
      ],
      bis: [],
      form: {
        electricityMeterName: "",
        electricityMeterModel: "",
        id: "",
        electricityMeterState: "",
        deviceState: null,
        electricityMeterSn: "",
        startDegree: "",
        endDegree: "",
        remark: "",
        cellId: "",
        chargingPileSn: "",
        chargeModel: "",
        chargeType: "",
        hardwareVersion: "",
        firmwareVersion: "",
        portNum: "",
        parameterId: "",
        chargingPileName: "",
        chargingPileState: "",
        deviceState: "",
        portId: "",
        portStateL: "",
        siteId: "",
        meterNum: ""
      },
      searchMeterVal: "",
      searchChargingPileSnVal: "",
      charts: [],
      isAllDevicePageTabs: Util.isPageTabsPerm("carportAllDeviceList"),
      isMeterPageTabs: Util.isPageTabsPerm("carportMeterList"),
      isChargePageTabs: Util.isPageTabsPerm("carportCharge"),
      isCarportPortPageTabs: Util.isPageTabsPerm("carportPort"),
      isDevicePageTabs: Util.isPageTabsPerm("carportDevice"),
      meterBtn: false, //Util.isHavePerm("electricityMeter/saveAddMeter"),
      chargePieBtn: Util.isHavePerm("chargePile/addChargePileInfo"),
      fictitiousBtn: Util.isHavePerm("batchUpload/batchFictitiousMeter"),
      carportBtn: Util.isHavePerm("guardInfo/bindGuard")
    };
  },
  components: {
    screenTime,
    pageSize,
    allDeviceList,
    carportMeter,
    carportCharge,
    portList,
    carportDevice
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "form.meterNum"(val, oldVal) {
      this.form.meterNum = Util.testNumberFn(val, "inputChangeNoDecimal");
    }
  },
  mounted() {
    if (this.params.val) {
      this.key = this.searchKye;
    }
    this.oldBis.find(item => {
      if (item.SHOW_TAB) {
        this.bis.push(item);
      }
    });

    let that = this;
    window.onresize = function() {
      setTimeout(_ => {
        that.resizeCharts();
      }, 500);
    };
    this.getEntry();
  },
  methods: {
    getSearchChargingPileSnVal(val) {
      this.searchChargingPileSnVal = val;
      this.chargingPileSnList = [];
      this.getChargingPileSnList(this.formData, val);
    },
    getSearchMeterVal(val) {
      this.searchMeterVal = val;
      this.searchMeterList = [];
      this.getMeterList(this.MeterData, val);
    },
    loadmore() {
      this.formData.pageIndex++;
      this.getChargingPileSnList(this.formData, this.searchChargingPileSnVal);
    },
    changeChargingPileSn() {
      this.chargingPileSnList.find(item => {
        if (item.CHARGING_PILE_SN == this.form.chargingPileSn) {
          this.form.chargingPileName = item.CHARGING_PILE_NAME;
        }
      });
    },
    changeElectricityMeterSn() {
      this.electricityMeterSnList.find(item => {
        if (item.ELECTRICITY_METER_SN == this.form.electricityMeterSn) {
          this.form.electricityMeterName = item.ELECTRICITY_METER_NAME;
          this.form.electricityMeterModel = item.ELECTRICITY_METER_MODEL;
        }
      });
    },
    getelectricityMeterSnList() {
      this.$http
        .get(`${Util.searchURL}/Meter/SearchByUseless?key=`)
        .then(res => {
          this.electricityMeterSnList = res.data.data;
        });
    },
    getChargingPileSnList(formData, val) {
      this.$http
        .get(
          `${Util.searchURL}/Pile/SearchByUseless/${formData.pageIndex}/${formData.pageSize}?key=${val}`
        )
        .then(res => {
          const _res = res.data.data.data; // 请求得到的数据
          this.chargingPileSnList = [...this.chargingPileSnList, ..._res];
          // this.chargingPileSnList = res.data.data.data;
        });
    },
    loadmoreMeter() {
      this.MeterData.pageIndex++;
      this.getMeterList(this.MeterData, this.searchMeterVal);
    },
    getMeterList(MeterData, val) {
      this.$http
        .get(
          `${Util.searchURL}/Meter/SearchByBind/${MeterData.pageIndex}/${MeterData.pageSize}?key=${val}`
        )
        .then(res => {
          const _res = res.data.data.data; // 请求得到的数据
          this.searchMeterList = [...this.searchMeterList, ..._res];
        });
    },
    searchMeter() {
      this.$http.get(`${Util.searchURL}/Meter/SearchByAll`).then(
        res => {
          if (res.data.code === 200) {
            this.searchMeterList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListByCarportAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    clickUrlPermisson(url) {
      return Util.clickUrlPermisson(url);
    },
    compare: val => {
      let modifier = val > 0 ? "+ " : "";
      let color = val > 0 ? "green" : "red;";
      return `<div style="color: ${color}">${modifier}${val}${
        val == "-" ? "" : "%"
      }</div>`;
    },
    resizeCharts() {
      for (let i = 0; i < this.charts.length; i++) {
        const chart = this.charts[i];
        chart.resize();
      }
    },
    showTab(el, type) {
      this.type = type;
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      if (type == 1) {
        this.$refs.allDeviceList.getList();
      } else if (type == 2) {
        this.$refs.carportMeter.getList();
      } else if (type == 3) {
        this.$refs.carportCharge.getList();
      } else if (type == 4) {
        this.$refs.portList.getList();
      } else if (type == 5) {
        this.$refs.carportDevice.getList();
      }
    },
    getAllCellList() {
      this.$http.get(`${Util.searchURL}/Carport/SearchByFlatComplex?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.allCellList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getSiteList(id) {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListBySiteByCell/${id}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.siteList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    getEntry() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/Info?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(result => {
          this.entry = result.data.data;
          $(function() {
            Dashmix.helpers([
              "easy-pie-chart",
              "sparkline",
              "datepicker",
              "flatpickr"
            ]);
          });
          // (entry.num_ports-entry.num_port_charging) || 0}}/{{entry.num_port_charging
          Util.initChart(
            this,
            "port",
            [],
            [
              {
                value: this.entry.num_ports - this.entry.num_port_charging,
                name: "空闲"
              },
              { value: this.entry.num_port_charging * 1, name: "占用" }
            ],
            "#FFB119",
            "pie",
            "个"
          );
        });
    },

    create(val) {
      this.formData = {
        pageIndex: 1,
        pageSize: 20
      };
      this.MeterData = {
        pageIndex: 1,
        pageSize: 20
      };
      if (val == "meterList") {
        this.getelectricityMeterSnList();
        jQuery("#modal-default-normal-meterList-add").modal("show");
      } else if (val == "chargePie") {
        this.searchMeterVal = "";
        this.searchChargingPileSnVal = "";
        this.chargingPileSnList = [];
        this.searchMeterList = [];
        this.getAllCellList();
        this.getMeterList(this.MeterData, this.searchMeterVal);
        this.getChargingPileSnList(this.formData, this.searchChargingPileSnVal);
        jQuery("#modal-default-normal-chargePie-add").modal("show");
      } else if (val == "carport") {
        this.searchCarport();
        jQuery("#modal-default-normal-carport-add").modal("show");
      } else if (val == "fictitious") {
        this.getAllCellList();
        jQuery("#modal-default-normal-fictitious-add").modal("show");
      }

      $(".btabs-animated-fade-" + this.type)[0].className =
        "nav-link active btabs-animated-fade-" + this.type;
      this.form = {
        electricityMeterName: "",
        electricityMeterModel: "",
        id: "",
        electricityMeterState: "",
        electricityMeterSn: "",
        startDegree: "",
        endDegree: "",
        remark: "",
        cellId: "",
        chargingPileSn: "",
        chargeModel: "",
        chargeType: "",
        hardwareVersion: "",
        firmwareVersion: "",
        portNum: "",
        parameterId: "",
        chargingPileName: "",
        chargingPileState: "",
        deviceState: "",
        portId: "",
        portStateL: "",
        id: "",
        status: "",
        entranceGuardName: "",
        deviceSn: "",
        carportId: "",
        direct: "",
        siteId: "",
        meterNum: ""
      };
      this.siteList = [];
      this.cellName = "";
      this.pro = "";
      this.city = "";
      this.dis = "";
    },
    submit(val) {
      let url = "";
      if (val == "meterList") {
        url = `${Util.operateURL}/electricityMeter/saveAddMeter`;
        this.form.deviceState = "1";
        this.form.electricityMeterState = "1";
      } else if (val == "chargePie") {
        url = `${Util.operateURL}/chargePile/addChargePileInfo`;
      } else if (val == "carport") {
        url = `${Util.operateURL}/guardInfo/bindGuard`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal-meterList-add").modal("hide");
            jQuery("#modal-default-normal-chargePie-add").modal("hide");
            jQuery("#modal-default-normal-carport-add").modal("hide");
            if (val == "meterList") {
              this.showTab(
                "btabs-animated-fade-" + this.bis[1].BIS_TYPE,
                this.bis[1].BIS_TYPE
              );
            }
            if (val == "chargePie") {
              this.showTab(
                "btabs-animated-fade-" + this.bis[2].BIS_TYPE,
                this.bis[2].BIS_TYPE
              );
            }
            if (val == "carport") {
              this.showTab(
                "btabs-animated-fade-" + this.bis[4].BIS_TYPE,
                this.bis[4].BIS_TYPE
              );
            }
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    fictitiousSubmit() {
      this.$http
        .post(
          `${Util.operateURL}/batchUpload/batchFictitiousMeter?siteId=${this.form.siteId}&meterNum=${this.form.meterNum}`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              jQuery("#modal-default-normal-fictitious-add").modal("hide");
              if (res.data.data.state == "失败" || res.data.data.failNum > 0) {
                Util.message(
                  "war",
                  "成功：" +
                    res.data.data.successNum +
                    "条，失败：" +
                    res.data.data.failNum +
                    "条"
                );
              } else {
                Util.message("succ", res.data.desc);
              }
              this.showTab(
                "btabs-animated-fade-" + this.bis[1].BIS_TYPE,
                this.bis[1].BIS_TYPE
              );
            } else {
              Util.message("err", res.data.desc);
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  }
};
</script>
<style scoped lang="less">
.badge {
  font-weight: 400 !important;
}
.custom-control-inline {
  margin-right: 3rem;
}
.custom-control {
  label {
    font-size: 0.9375rem;
    font-weight: 400;
  }
}
</style>